import createWithBsPrefix from './createWithBsPrefix';
export default createWithBsPrefix('card-columns');


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-bootstrap/esm/CardColumns.js
// module id = 1200
// module chunks = 11